
const Separator = () => {

    return (
        <hr style={{borderTop: '1px solid #ECEEFE', width: '100%', maxWidth:'100%'}} />
    )
}

export default Separator